import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import QuantFilter from './quant/QuantFilter';
import ReportContent from './quant/ReportContent';
import InterestFilter from './quant/InterestFilter';
import Description_Box from '../components/description/Description';
import QuantService from '../../service/quant/Quant';

export interface groupProps {
  group: string;
  group_idx: number;
}

export interface QuantProps {
  qh_idx: number;
  group_idx?: number;
  quant_idx: number;
  region: string;
  category: string;
  roi: number;
  roe: number;
  tags: [];
  type: number;
  ex_bid_prc: string;
  ex_sale_prc: string;
  margin: string;
  caseno: string;
  court: string;
  analysis_time: string;
  memo?: string;
  search_category: string[];
}

function QuantReport() {
  const [groupList, setGroupList] = useState<groupProps[]>([]);
  const [selectedTab, setSelectedTab] = useState<'전체' | '관심 리포트'>(
    '전체',
  );

  const getCode = (region: string) => {
    const regObj: Record<string, string> = {
      전국: '',
      서울: '11',
      경기: '41',
      인천: '28',
      부산: '26',
      대전: '30',
      대구: '27',
      울산: '31',
      세종: '36',
      강원: '42',
      충북: '43',
      충남: '44',
      경북: '47',
      경남: '48',
      광주: '29',
      전북: '45',
      전남: '46',
      제주: '50',
    };
    return regObj[region as keyof typeof regObj] ?? '';
  };

  const [selectedFilters, setSelectedFilters] = useState<{
    theme: string[];
    region: string[];
    category: string[];
    date: string;
  }>({
    theme: [],
    region: [],
    category: [],
    date: '',
  });
  const [selectedInterestType, setSelectedInterestType] = useState(0);
  const [list, setList] = useState<QuantProps[]>([]);
  const [totalCount, setTotalCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const limit = 9;

  const getGroupList = async () => {
    try {
      const res = await QuantService.groupList();
      setGroupList(res.data);
    } catch (err) {
      console.log(err, '발생');
    }
  };

  const getQuantList = async () => {
    const { theme, region, category, date } = selectedFilters;

    const data = {
      theme: theme.join(','),
      sidoCode: region.map(getCode).join(','),
      category: category.join(','),
      isInterest: selectedTab === '관심 리포트' ? 'Y' : '',
      groupIdx:
        selectedTab === '관심 리포트' && selectedInterestType !== 0
          ? String(selectedInterestType)
          : '',
      analysisDate: date,
      limit,
      page: currentPage,
    };

    try {
      const res = await QuantService.userList(data);
      console.log(data.analysisDate);
      if (res.data) {
        setTotalCount(res.data.totalCount);
        setList(
          res.data.list.map((el: any) => {
            let tags = [];
            let type = 0;
            if (el.roi < 5 && el.roe < 7) {
              tags.push('안정형');
              type = 1;
            } else if (el.roi >= 5 && el.roi < 7 && el.roe >= 6 && el.roe < 9) {
              tags.push('안정추구형');
              type = 2;
            } else if (
              el.roi >= 7 &&
              el.roi < 10 &&
              el.roe >= 8 &&
              el.roe < 12
            ) {
              tags.push('위험중립형');
              type = 3;
            } else if (
              el.roi >= 10 &&
              el.roi < 15 &&
              el.roe >= 12 &&
              el.roe < 20
            ) {
              tags.push('적극투자형');
              type = 4;
            } else if (el.roi >= 15 && el.roe >= 20) {
              tags.push('공격투자형');
              type = 5;
            }

            tags.push(Math.ceil(el.pyeong / 10) * 10 + '평 이하');
            if (el.years) {
              tags.push('노후 ' + Math.ceil(el.years / 10) * 10 + '년 이하');
            }

            return {
              qh_idx: el.qh_idx,
              group_idx: el.group_idx,
              quant_idx: el.quant_idx,
              region: el.region,
              category: el.category,
              roi: el.roi,
              roe: el.roe,
              tags: tags,
              type,
              ex_bid_prc: el.ex_bid_prc,
              ex_sale_prc: el.ex_sale_prc,
              margin: el.margin,
              caseno: el.caseno,
              court: el.court,
              analysis_time: el.analysis_time,
              memo: el.memo,
              search_category: el.search_category
                ? el.search_category.split(',')
                : [],
            };
          }),
        );
      }
    } catch (error) {
      console.error('userList API 에러:', error);
    }
  };

  useEffect(() => {
    getGroupList();
  }, []);

  useEffect(() => {
    setCurrentPage(1);
    getQuantList();
  }, [selectedFilters, selectedTab, selectedInterestType]);

  useEffect(() => {
    getQuantList();
  }, [currentPage]);

  return (
    <Container>
      <TitleContainer>
        <Title>퀀트 분석 리포트</Title>
        <Description_Box
          desc1="다양한 테마별 퀀트 전략으로 분석한 리포트를 한 눈에 모아보세요!"
          desc2="즐겨찾기, 메모 기능 및 퀀트, 지역, 유형별로 찾아보고 분석 날짜별로도 찾아볼 수 있습니다."
        />

        <TabBox>
          {['전체', '관심 리포트'].map((label) => (
            <Tab
              key={label}
              selected={selectedTab === label}
              onClick={() => setSelectedTab(label as '전체' | '관심 리포트')}
            >
              {label}
            </Tab>
          ))}
        </TabBox>
        <QuantFilter
          selectedFilters={selectedFilters}
          setSelectedFilters={setSelectedFilters}
        />
      </TitleContainer>
      <ContentBox>
        {selectedTab === '관심 리포트' && (
          <InterestFilter
            selectedInterestType={selectedInterestType}
            setSelectedInterestType={setSelectedInterestType}
            groupList={groupList}
          />
        )}
        <ReportContent
          list={list}
          groupList={groupList}
          totalCount={totalCount}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          limit={limit}
          getQuantList={getQuantList}
        />
      </ContentBox>
    </Container>
  );
}

export default QuantReport;

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  margin-top: 24px;
`;

const TitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 0 16px 24px;
  gap: 14px;
  background-color: #ffffff;
`;
const Title = styled.div`
  font-weight: 700;
  font-size: 16px;
  line-height: 145%;
  letter-spacing: -2%;
`;

const TabBox = styled.div`
  display: flex;
  flex-direction: row;
  border-radius: 8px;
  padding: 4px;
  background: #70737c0d;
`;

const Tab = styled.div<{ selected: boolean }>`
  flex: 1;
  padding: 8px 16px;
  border-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;

  background-color: ${({ selected }) => (selected ? '#ffffff' : 'transparent')};
  color: ${({ selected }) => (selected ? '#222222' : '#989BA2')};
  box-shadow: ${({ selected }) =>
    selected
      ? `
    0px 0px 1px 0px #383A3B14,
    0px 1px 4px 0px #383A3B14,
    0px 2px 8px 0px #383A3B1F
  `
      : 'none'};
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0%;
`;

const ContentBox = styled.div`
  background-color: #f7f8fc;
  padding: 24px 16px;
  display: flex;
  flex-direction: column;
  gap: 24px;
`;
